// m’ / purpose’ / coin_type’ / account’ / change / address_index
const paths = 'm’/44’/60’/0’/0';
export default paths;
